import FilialApiService from "../../../../services/api/FilialApiService";

const baseAliqOptions = [
    { label: '...', value: '' },
    { label: 'Custo adicional', value: 'beneficio' },
    { label: 'Salario', value: 'salario' }
];

export const getFormFields = async () => {
    //const filiaisData = await (FilialApiService.getAll()).then(resp => resp.data);

    return {
        groups:[
            /* {
                header: '',
                fields: [
                    {
                        label: 'Unidade',
                        placeholder: 'Ex: Vertigo Rio',
                        name: 'filialCod',
                        type: 'select',
                        size: 3,
                        options: [
                            { value: '0', label: '--- Todas ---' },
                            ...(filiaisData.data.map(item => ({
                                    value: item.cod,
                                    label: item.label
                                })
                            )),
                        ],
                        defaultValue: 0
                    },
                ]
            }, */
            {
                header: 'Valor e Período de Custo',
                fields: [
                    {
                        label: 'Valor Custo',
                        name: 'valor',
                        type: 'currency',
                        size: 4,
                        defaultValue: 0
                    },
                    {
                        label: 'Período de Aplicação Custo',
                        name: 'periodoValor',
                        type: 'select',
                        options: [
                            { label: '...', value: '' },
                            { label: 'Diário', value: 'dia' },
                            { label: 'Mensal', value: 'mes' },
                        ],
                        size: 4,
                    },
                    {
                        label: 'Base Aliq. Pago Unidade',
                        name: 'baseAliqFilial',
                        type: 'select',
                        options: baseAliqOptions,
                        size: 4,
                    },
                ]
            }
        ]
    }
}

const BeneficioValorFormInfo = {
    getFormFields
}

export default BeneficioValorFormInfo;
